import { FC } from "react";

import styles from "./applicability.module.scss";

export const Applicabilty: FC = () => {
  return <div>Применяемость</div>;
};
